export default __webpack_public_path__ + "static/media/fad-hardclip.a17479e6.svg";